import React from 'react'
import { ActionIcon } from '@mantine/core'
import { IconBrandLinkedin } from '@tabler/icons-react'

/**
 * Renders the LinkedIn link.
 * @param {string} url The LinkedIn URL.
 * @param {string} color The text color for the button.
 * @returns {JSX.Element}
 */
function LinkedInIcon ({ url, color }) {
  return (
    <ActionIcon
      variant='filled'
      color={color}
      aria-label='LinkedIn'
      size='sm'
      component='a'
      href={url}
      target='_blank'
      autoContrast
    >
      <IconBrandLinkedin stroke={2} aria-label='Follow on LinkedIn' />
    </ActionIcon>
  )
}

export default React.memo(LinkedInIcon)
